import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index'
import { installTheme } from '@/theme'
import { installThemeMode } from '@/theme/mode'
import '@/theme/fonts'
import '@/theme/base.css'

installTheme()
installThemeMode()

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// Initialize auth store BEFORE adding router
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore(pinia)
await authStore.initialize()

app.use(router)
app.mount('#app')
